module.exports = __webpack_public_path__ + "img/logo_app.19182012.png";